import gql from 'graphql-tag'

// to be generated after checking the api
export const LIST_USERS_ORG_QUERY = gql`
    query MyOrganisations($pagination: PaginationInput, $filters: OrganisationWhereInput) {
        myOrganisations(pagination: $pagination, filters: $filters) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            totalCount
            edges {
                node {
                    id
                    devices
                    users
                    organisation {
                        id
                        name
                        isActive
                        billingAddressLine1
                        billingAddressLine2
                        billingAddressCity
                        billingAddressState
                        billingAddressCountry
                        billingGstin
                        billingEmail
                        billingEnabled
                        organisationLimit
                        parentOrganisation {
                            id
                            name
                        }
                        rootOrganisation {
                            id
                            name
                            billingAddressLine1
                            billingAddressLine2
                            billingAddressCity
                            billingAddressState
                            billingAddressCountry
                            billingGstin
                            billingEmail
                            billingEnabled
                        }
                    }
                    hierarchy {
                        id
                        name
                    }
                    organisationUser {
                        id
                        roleID
                        role {
                            id
                            name
                        }
                    }
                    permissions
                    delegatedOrganisation {
                        id
                        name
                    }
                }
            }
        }
    }`
